import CoAuthorsListItem from '@/src/coAuthors/components/CoAuthorsListItem';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../styles/CoAuthorsList.module.css';

interface CoAuthorsListProps {
  list: Array<coAuthorProps>;
}

export interface coAuthorProps {
  name: string;
  id: string;
  picture?: string | undefined;
}

const CoAuthorsList = ({list}: CoAuthorsListProps) => {
  if (!list || !list.length) {
    return null;
  }

  return (
    <div id={'co-authors-section'} className={css.authorsSection}>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_36}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
        >
          <TextLocal id={'courseDetails.co-authors'} />
        </Text>
      </div>

      <ul className={css.list}>
        {list.map((coAuthor) => (
          <li key={coAuthor.id}>
            <CoAuthorsListItem coAuthor={coAuthor} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CoAuthorsList;
